export const it = {
    languages: {
      english: "Inglese",
      spanish: "Spagnolo",
      dutch: "Olandese",
      french: "Francese",
      portuguese: "Portoghese",
      italian: "Italiano",
      german: "Tedesco",
      polish: "Polacco",
      romanian: "Rumeno",
      greek: "Greco",
      //TODO: add new language here
    },
    loginPage: {
      title: "Accedi",
      email: "Email",
      placeholder: "Inserisci la tua email",
      buttonText: "Accedi",
      loginMessage:
        "È stata inviata un'email all'indirizzo fornito. Clicca sul link nell'email per autenticarti.",
      noEmailMessage:
        "Per favore, usa il link nell'email che ti è stata inviata per avviare questo processo",
    },
    formPage: {
      title: "Revisione Periodica",
      submittedMessage: "Il modulo è stato inviato!",
      alreadySubmittedMessage:
        "Il modulo è già stato inviato! Se desideri modificare le informazioni precedentemente inviate, contatta il tuo relationship manager.",
      waitMessage: "Caricamento dati, attendere prego...",
      asteriskMessage1: "Si prega di compilare tutti i campi con",
      asteriskMessage2: "poiché sono obbligatori.",
      savedLocallyMessage: "Tutte le modifiche verranno salvate localmente sul tuo dispositivo.",
      accessFormAgain: "Puoi accedere nuovamente al modulo usando il link",
      openPRs: "Revisioni Periodiche Aperte",
      addRelation: "Aggiungi Relazione",
      submit: "Invia",
      continue: "Continua",
      addFile: "Aggiungi File",
    },
  };